export default __webpack_public_path__ + "static/media/pic-left.5b12972e.svg";